module.exports = __webpack_public_path__ + "img/builder.7a6bcdba.svg";